import { useCallback, useState } from 'react'

export type UseDialogReturnType = {
    isOpen: boolean
    show: () => void
    hide: () => void
    toggle: (show?: boolean) => void
}

export const useDialog = (defaultShow: boolean) => {
    const [isOpen, setIsOpen] = useState(defaultShow)

    const show = useCallback(() => {
        setIsOpen(true)
    }, [])

    const hide = useCallback(() => {
        setIsOpen(false)
    }, [])

    const toggle = useCallback((show?: boolean) => {
        setIsOpen(current => {
            return show ?? !current
        })
    }, [])

    return {
        isOpen,
        show,
        hide,
        toggle,
    }
}
